const FilterIcon = () => {
  return (
    <svg
      id='Group_37099'
      data-name='Group 37099'
      xmlns='http://www.w3.org/2000/svg'
      width='23.977'
      height='24'
      viewBox='0 0 23.977 24'
    >
      <path
        id='filter_3_'
        data-name='filter (3)'
        d='M.749,3.99H12.157a3.49,3.49,0,0,0,6.816,0h4.254a.749.749,0,1,0,0-1.5H18.973a3.489,3.489,0,0,0-6.816,0H.749a.749.749,0,1,0,0,1.5Zm12.826-.747s0-.005,0-.008a1.99,1.99,0,0,1,3.981,0v.011a1.991,1.991,0,0,1-3.981,0Zm9.653,16.27H18.973a3.489,3.489,0,0,0-6.816,0H.749a.749.749,0,1,0,0,1.5H12.157a3.49,3.49,0,0,0,6.816,0h4.254a.749.749,0,0,0,0-1.5Zm-7.662,2.74a1.993,1.993,0,0,1-1.991-1.986v0s0-.005,0-.008a1.99,1.99,0,0,1,3.981,0v.011a1.993,1.993,0,0,1-1.991,1.988ZM23.228,11H11.82A3.49,3.49,0,0,0,5,11H.749a.749.749,0,0,0,0,1.5H5a3.489,3.489,0,0,0,6.816,0H23.228a.749.749,0,1,0,0-1.5ZM10.4,11.75s0,.005,0,.008a1.99,1.99,0,0,1-3.981,0v-.011a1.991,1.991,0,0,1,3.981,0Z'
        transform='translate(0 0.248)'
        fill='#404650'
      />
    </svg>
  );
};

export default FilterIcon;
